module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-side-bar-menu-wrapper">\n  <div class="fmcy-side-bar-menu-left-area">\n    <div class="fmcy-menu-button-group fmcy-menu-button-group-profile fmcy-menu-account-info">\n      ';
 if (isUserLoggedIn === true) { 
__p+='\n      <div class="fmcy-menu-button-item fmcy-menu-account-info-display-name">\n        <div class="fmcy-menu-account-info-display-name-icon"></div> Hi, <a href="'+
((__t=(rootUrl))==null?'':__t)+
'/my-account"><span class="display-name">'+
((__t=(displayName))==null?'':__t)+
'</span></a>\n      </div>\n      <div class="fmcy-customer-my-orders-region"></div>\n      ';
 } else { 
__p+='\n        <div class="fmcy-menu-button-item fmcy-menu-account-info-display-name login-button">\n          <div class="fmcy-menu-account-info-display-name-icon"></div> Login\n        </div>\n        <div class="fmcy-menu-button-item register-button">Join</div>\n      ';
 } 
__p+='\n    </div>\n    <div class="fmcy-menu-button-group">\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/menu-intro">Menu</a></div>\n      ';
 if (isUserLoggedIn === true) { 
__p+='\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/my-account/#account-details">My Account</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/my-favourites/">My Favourites</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/my-account/#orders">Order History</a></div>\n      ';
 } 
__p+='\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/promotions-members/">Weekly Sale</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/click-and-collect/">Click and Collect</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/locations/">Locations</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/gallery/">Gallery</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/contact/">Contact</a></div>\n    </div>\n    <div class="fmcy-menu-button-group">\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/bookconsultation/">Book a Consultation</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/frequently-asked-questions/">FAQ</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/licensed-producers/">Licensed Producers</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/the-original-farm-about-us/">About</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/careers/">Careers</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/psa/">COVID 19</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'">Home</a></div>\n    </div>\n    ';
 if (isUserLoggedIn === true) { 
__p+='\n      <div class="fmcy-menu-button-group">\n        <div class="fmcy-menu-button-item"><a href="'+
((__t=(rootUrl))==null?'':__t)+
'/?lrm_logout=1">Logout</a></div>\n      </div>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/sidebar/sidebar-modal/sidebar-modal.html
 ** module id = 1076
 ** module chunks = 1 85
 **/